export const isInvalidCode = (input: string): boolean => {
  const hasPrefix = /^(v-|u-|f-)/i.test(input);

  if ((hasPrefix && input.length < 12) || (!hasPrefix && input.length < 10)) {
    return false;
  }

  const prefixPattern = /^(v-|u-|f-)[A-Za-z0-9]{10}$/i;
  const plainPattern = /^[A-Za-z0-9]{10}$/;

  if (prefixPattern.test(input) || plainPattern.test(input)) {
    return false;
  }

  return true;
};

export const isValidCode = (input: string): boolean => {
  const prefixPattern = /^(v-|u-|f-)[A-Za-z0-9]{10}$/i;
  const plainPattern = /^[A-Za-z0-9]{10}$/;

  return prefixPattern.test(input) || plainPattern.test(input);
};
